import React from 'react';
import { components } from 'react-select';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const CustomSelectOptionElement = (props) => (
  <Tippy
    content={
      <div>
        <p className="font12">
          <strong>Standard Toolbox items:</strong>{' '}
          {props.data.item.tools.map((tool, i, arr) => (
            <span key={tool}>
              {tool}{i === arr.length - 1 ? '.' : ', '}
            </span>
          ))}
        </p>
        <p className="font12">
          <strong>Standard Materials:</strong>{' '}
          {props.data.item.materials.map((material, i, arr) => (
            <span key={material}>
              {material}{i === arr.length - 1 ? '.' : ', '}
            </span>
          ))}
        </p>
      </div>
    }
    placement="left"
    interactive
  >
    <div>
      <components.Option {...props} />
    </div>
  </Tippy>
);

export default CustomSelectOptionElement;
